import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import HeroBanner from '../../home/HeroBanner/HeroBanner'
import Header from '../Header/container/Header'
import Footer from '../Footer/container/Footer'

import homeBackground from '../../../assets/img/homeBackground.svg'

import media from '../../../services/generateMediaQueries'
import Universal from '../../ads/Universal/Universal'

import {
  getUserAgreementStatus,
  postUserAgreement,
} from '../../../services/api/requests/Dashboard'
import TnCAndPNModal from '../../home/TnCAndPNModal/TnCAndPNModal'
import { setGAEvent } from '../../../services/analytics/google-analytics'
import SpinAndWin from '../../home/SpinAndWin/containers/SpinAndWin'

const Layout = styled.div`
  position: relative;
  min-height: 100vh;
  width: 100%;
  overflow: hidden;
  margin-top: -80px;
`
const ContentWrapper = styled.div`
  position: relative;
`
const ContentOverflowHelper = styled.div`
  position: relative;

  &::before {
    content: ' ';
    position: absolute;
    top: 600px;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('${homeBackground}');
  }
`
const Content = styled.div`
  min-height: 100vh;

  ${media.lessThan('medium')`
    padding: 0 1.5rem;
  `}
`
const Container = styled.div`
  position: relative;
`

function DashboardLayout(props) {
  const {
    heroBannerLeft,
    heroBannerData,
    heroBannerTitle,
    heroLink,
    handleChangeMall,
    redirectToWayfinding,
    redirectToMallDirectory,
    favoriteMalls,
    selectedMall,
    showMallDropdown,
    errors,
    children,
    match,
    variant,
    displayProfileModal,
    setProfileModalPage,
    setTransportationMall,
    featuredSection,
    hasFooter = true,
    dropdownCaption,
    actionLabel,
    readMoreLink,
    selectedMallSlugName,
    bannerTitleOnSide,
    accessToken,
    previewMode,
    // altHeaderAd,
    // altFooterAd,
  } = props

  const [tncAgreement, setTnC] = useState(true)
  const [privacyAgreement, setPrivacy] = useState(true)

  useEffect(() => {
    if (accessToken) {
      getTermsStatus()
    } else {
      setTnC(true)
      setPrivacy(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken])

  const getTermsStatus = async () => {
    try {
      const { data } = await getUserAgreementStatus(accessToken)
      const { tnc, privacy } = data || {}
      setTnC(tnc)
      setPrivacy(privacy)
      if (!tnc || !privacy) {
        setGAEvent('screen_view', 'Login - Condensed TnC/PN')
      }
    } catch {}
  }
  const onUserAgree = async () => {
    try {
      const agreementValue = {
        privacy: true,
        tnc: true,
      }
      const { data } = await postUserAgreement(accessToken, agreementValue)
      const { tnc, privacy } = data || {}
      setTnC(tnc)
      setPrivacy(privacy)
    } catch (e) {}
  }

  return (
    <>
      <Universal id="universal" />
      <Header
        match={match}
        initialMall={selectedMall}
        previewMode={previewMode}
      />
      <Layout>
        <HeroBanner
          heroBannerLeft={heroBannerLeft}
          desktopBackgroundUrl={
            (heroBannerData &&
              heroBannerData.desktopBanner &&
              heroBannerData.desktopBanner.url) ||
            ''
          }
          title={heroBannerTitle}
          caption={(heroBannerData && heroBannerData.caption) || ''}
          subCaption={(heroBannerData && heroBannerData.subCaption) || ''}
          layout={(heroBannerData && heroBannerData.layout) || 1}
          exploreLink={heroLink}
          handleChangeMall={handleChangeMall}
          dropdownCaption={dropdownCaption}
          redirectToWayfinding={redirectToWayfinding}
          redirectToMallDirectory={redirectToMallDirectory}
          favoriteMalls={favoriteMalls}
          selectedMall={selectedMall}
          errors={errors}
          variant={variant}
          bannerTitleOnSide={bannerTitleOnSide}
          showMallDropdown={showMallDropdown}
          displayProfileModal={displayProfileModal}
          setProfileModalPage={setProfileModalPage}
          setTransportationMall={setTransportationMall}
          actionLabel={actionLabel}
          readMoreLink={readMoreLink}
          selectedMallSlugName={selectedMallSlugName}
          featuredSection={featuredSection}
        />
        <ContentWrapper>
          <ContentOverflowHelper>
            <Content>
              <Container>{children}</Container>
            </Content>
          </ContentOverflowHelper>
          {!!hasFooter && <Footer match={match} altFooterAd />}
        </ContentWrapper>
      </Layout>
      <TnCAndPNModal
        show={accessToken && (!privacyAgreement || !tncAgreement)}
        onAgree={onUserAgree}
      />
      <SpinAndWin canShow={accessToken && (privacyAgreement || tncAgreement)} />
    </>
  )
}

DashboardLayout.defaultProps = {
  // TODO: specify default props
}

DashboardLayout.propTypes = {
  // TODO: specify prop types
}

export default DashboardLayout
